import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiLinks } from '@cutting/app.api-links';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { JWTWebToken } from 'cloud-shared-lib';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class TokenManagerService {
  private readonly urlUpdateAccessToken: string = ApiLinks.updateAccessToken;

  constructor(private http: HttpClient, private router: Router) {}

  logout(): void {
    const userIdLS = LocalStorageManager.regData;
    if (userIdLS) {
      LocalStorageManager.removeRegData();
    }

    LocalStorageManager.removeClient();
    this.router.navigate(['/client/auth/login'], {
      queryParams: userIdLS ? { user: userIdLS } : null,
    });
  }

  getAccessToken(): string | null {
    const tokens = this.getTokens();
    return tokens === null ? null : tokens.access;
  }

  getTokens(): JWTWebToken | null {
    const LSC = LocalStorageManager.client;

    if (LSC) {
      return LSC.token;
    }

    return null;
  }

  setAccessToken(token: string): boolean {
    const LSC = LocalStorageManager.client;

    if (LSC) {
      LSC.token.access = token;
      LocalStorageManager.client = LSC;

      return true;
    }

    return false;
  }

  updateAccessToken(): Observable<{ access: string }> {
    return this.http.post(this.urlUpdateAccessToken, this.getTokens()).pipe(
      tap((token: { access: string }) => this.setAccessToken(token.access)),
      catchError(() => {
        this.logout();
        return of({ access: '' });
      })
    );
  }

  getRefreshToken(): string | null {
    const tokens = this.getTokens();
    return tokens === null ? null : tokens.refresh;
  }
}
